/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Logger } from './model';

/**
 * Create a function that will store calls to it in a queue until
 * the queue is flushed.
 */
const makeQueueable = <
  O extends Record<string, (...args: any[]) => any>,
  K extends keyof Logger,
  P extends Parameters<O[K]> = Parameters<O[K]>,
>(
  obj: O,
  key: K,
): (() => void) => {
  let queue: Array<P> = [];
  let initialized = false;
  const originalFn = obj[key];
  obj[key] = ((...args: P) => {
    if (!initialized) {
      queue.push(args);
      return;
    }
    originalFn(...args);
  }) as any;
  return () => {
    if (initialized) {
      return;
    }
    initialized = true;
    queue.forEach((args) => {
      obj[key](...args);
    });
    queue = [];
  };
};

export const queueLogFns = (logger: Logger, fns: (keyof Logger)[]) => {
  const queues = fns.map((key) => makeQueueable(logger as any, key));
  return () => {
    queues.forEach((flush) => flush());
  };
};
